export default "__VITE_ASSET__efe77017__"